import type en from './locales/en.json'
import { supportedLanguages } from './languages'

// Bundle all supported locales locally; native WebViews need no extra request.
const locales = import.meta.glob<{ default: typeof en }>('./locales/*.json', {
  eager: true,
})

export const resources = Object.fromEntries(
  supportedLanguages.map(language => [
    language,
    { translation: locales[`./locales/${language}.json`].default },
  ])
)
